import React from 'react'
import { Link, LinkProps, NavLinkProps } from 'react-router-dom'

import List, { ListProps } from '@material-ui/core/List'
import ListItem, { ListItemProps } from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles'

import T from 'components/FormattedMessage'

interface Props extends ListProps {
}

const innerLink = (to: LinkProps['to']) => ({ innerRef, ...props }: ListItemProps) => (
  <Link {...props as NavLinkProps} to={to} />
)

const outerLink = (href: string) => ({ children, ...props }: ListItemProps<'a'>) => (
  <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
    {children}
  </a>
)

const styles = createStyles({
  icon: {
    marginRight: 0,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const ProfileLinks: React.SFC<InjectedProps> = ({ classes, ...props }) => {
  const { icon, ...otherClasses } = classes

  return (
    <List {...props} classes={otherClasses}>
      <ListItem divider>
        <ListItemText
          primary={<T id="userprofile_section_appinfo" />}
        />
      </ListItem>

      <ListItem component={innerLink('/tutorial')} divider button>
        <ListItemText
          primary={<T id="userprofile_tutorial_title" />}
          secondary={<T id="userprofile_tutorial_subtitle" />}
        />
        <ListItemIcon classes={{ root: icon }}>
          <KeyboardArrowRight />
        </ListItemIcon>
      </ListItem>

      <ListItem component={innerLink('/rules')} divider button>
        <ListItemText
          primary={<T id="userprofile_rules_title" />}
          secondary={<T id="userprofile_rules_subtitle" />}
        />
        <ListItemIcon classes={{ root: icon }}>
          <KeyboardArrowRight />
        </ListItemIcon>
      </ListItem>

      <ListItem component={outerLink('https://foosio.zendesk.com/hc/de/articles/214109329-FAQs')} divider button>
        <ListItemText
          primary={<T id="userprofile_faq_title" />}
          secondary={<T id="userprofile_faq_subtitle" />}
        />
        <ListItemIcon classes={{ root: icon }}>
          <KeyboardArrowRight />
        </ListItemIcon>
      </ListItem>

      <ListItem component={outerLink('https://foosio.com/terms-and-conditions')} divider button>
        <ListItemText
          primary={<T id="userprofile_toc_title" />}
          secondary={<T id="userprofile_toc_subtitle" />}
        />
        <ListItemIcon classes={{ root: icon }}>
          <KeyboardArrowRight />
        </ListItemIcon>
      </ListItem>

      <ListItem component={outerLink('https://foosio.com/impressum')} divider button>
        <ListItemText
          primary={<T id="userprofile_company_title" />}
          secondary={<T id="userprofile_company_subtitle" />}
        />
        <ListItemIcon classes={{ root: icon }}>
          <KeyboardArrowRight />
        </ListItemIcon>
      </ListItem>
    </List>
  )
}

export default withStyles(styles)(ProfileLinks)
